






















































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { RegionsModule } from '@/store/Settings/RegionsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import CreateRegionRequest from '@/models/Settings/Regions/CreateRegionRequest';
import PageNames from '@/router/PageNames';
import TimezoneUtils from '@/lib/timezoneUtils';
import CultureUtils from '@/lib/cultureUtils';

@Component({ name: 'RegionCreate' })
export default class extends SaascadaVueDialog {

  request: CreateRegionRequest = new CreateRegionRequest();

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreateRegionRequest();
            // By default setting the working days of the week to all on
            this.request.workingDays.MONDAY = true;
            this.request.workingDays.TUESDAY = true;
            this.request.workingDays.WEDNESDAY = true;
            this.request.workingDays.THURSDAY = true;
            this.request.workingDays.FRIDAY = true;
            this.request.workingDays.SATURDAY = true;
            this.request.workingDays.SUNDAY = true;
        }
    }

    get listOfTimezones() {
        return TimezoneUtils.getListOfTimezones();
    }

    get listOfCultures() {
        return CultureUtils.getListOfCultures();
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await RegionsModule.createRegion(this.request);

            if (RegionsModule.newRegionId != null) {
                this.$router.push({ name: PageNames.Region, params: { id: RegionsModule.newRegionId } });
            }
        }
    }

    get availableCurrencies() {
        return AuthModule.me.institution.config.availableCurrencies;
    }

}
